import { useEffect } from 'react';
import Breadcrumb from '../../../Common/Breadcrumb';
import IncomeVsExpenseView from './IncomeVsExpenseView';
import { setInitialFilterConf } from '../../../slices/filters/thunk';
import { useDispatch } from "react-redux";

const InsightsIncomeVsExpense = () => {
  document.title = "Prihodki in odhodki" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: { aggregation_period: 'month', amount_field: 'amount_no_tax' },
      hidden: ['intent_type', 'intent_checkboxes_group'],
      disabled: ['search'],
      masterSearch: true,
    }));
  }, []);

  return (
    <>
      <Breadcrumb parentTitle="Vpogledi" pageTitle="Prihodki in odhodki" />
      <IncomeVsExpenseView />
    </>
  );
};

export default InsightsIncomeVsExpense;
